import { Component, Input } from '@angular/core';
import { Store } from '@ngrx/store';

import { DeviceInfo, SimsV2Sim, Line } from 'src/app/core';
import { actionDistributorNamesListGet } from 'src/app/core/store/distributors/distributors.actions';

@Component({
  selector: 'app-end-users-more-info',
  templateUrl: './end-users-more-info.component.html',
  styleUrls: ['./end-users-more-info.component.less'],
})
export class EndUsersMoreInfoComponent {
  SIM_MORE_INFO_PREFIX = 'PAGE.MOBILE.END_USERS.OVERVIEW.SIMS.MORE_INFO';
  activateOnAttach: boolean = false;

  @Input() consumerIdentityUuid: string;
  @Input() brandUuid: string;
  @Input() sim: SimsV2Sim;
  @Input() line: Line;
  @Input() device: DeviceInfo;
  @Input() brandConfigActivateOnAttach: boolean;

  constructor(private store: Store) {}

  getStrPath(path) {
    return `${this.SIM_MORE_INFO_PREFIX}.${path}`;
  }

  ngOnInit() {
    if(this.sim?.distributorId) {
      this.fetchDistributor();
    }
    this.setActivateOnAttach();
  }

  fetchDistributor() {
    this.store.dispatch(
      actionDistributorNamesListGet({
        body: { distributorIds: [this.sim.distributorId] },
      })
    );
  }

  setActivateOnAttach() {
    this.activateOnAttach = this.line.hasOwnProperty('activateOnAttach')
      ? this.line.activateOnAttach
      : this.brandConfigActivateOnAttach;
  }
}
